module.exports = __webpack_public_path__ + "static/media/create-door.0b0d383b.gif";